import * as React from 'react';
import { mapContactLensesToDraftLineItems, FindAStoreCTA, BookAppointmentCTA } from '@grandvisionhq/fun-products';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../../Context/ProductDetailContext.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { CLAddToCartCTA } from './components/CLAddToCartCTA/CLAddToCartCTA.js';
import { DummyAddToCartCTA } from './components/DummyAddToCartCTA/DummyAddToCartCTA.js';

/** @deprecated */ const ContactLensesCTA = ({ className  })=>{
    const { isContactLensEnabled  } = useFeatureToggles();
    const { routes , activeVariant  } = useProductDetailContext();
    const storesRoute = routes.stores;
    const { state , selectors  } = useCLEcommContext();
    const { isConfiguratorValid  } = state.configurator;
    const hasQueryError = selectors.hasQueryError(state);
    const hasNonOrderableProduct = selectors.hasNonOrderableProduct(state);
    // Prevent adding to cart if there is any query error in any enabled column
    const lineItemDrafts = React.useMemo(()=>!hasQueryError ? mapContactLensesToDraftLineItems(state) : []
    , [
        state
    ]);
    // On the CL PDP, the activeVariant is always the masterVariant
    if (activeVariant.excludedFromCheckout || hasNonOrderableProduct) {
        return /*#__PURE__*/ React.createElement(FindAStoreCTA, {
            className: className,
            href: storesRoute
        });
    }
    if (!isContactLensEnabled) {
        return /*#__PURE__*/ React.createElement(BookAppointmentCTA, {
            className: className,
            href: storesRoute
        });
    }
    if (isContactLensEnabled && isConfiguratorValid && lineItemDrafts.length > 0) {
        return /*#__PURE__*/ React.createElement(CLAddToCartCTA, {
            className: className,
            lineItemDrafts: lineItemDrafts
        });
    }
    return /*#__PURE__*/ React.createElement(DummyAddToCartCTA, {
        className: className
    });
};

export { ContactLensesCTA };
//# sourceMappingURL=ContactLensesCTA.js.map
